import React from 'react';
import { Globe, Users, Rocket } from 'lucide-react';

const RightMathsZone = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <Globe className="w-8 h-8 text-green-600" />
          <h1 className="text-3xl font-bold text-gray-900">RightMaths Zone</h1>
        </div>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          探索RightMaths的創新學習區域，體驗全新的數學學習體驗
        </p>
      </div>

      {/* Content Placeholder */}
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="text-center space-y-4">
          <Users className="w-16 h-16 text-green-500 mx-auto" />
          <h2 className="text-2xl font-semibold text-gray-800">學習區域</h2>
          <p className="text-gray-600 max-w-md mx-auto">
            這個功能正在開發中，將提供互動式學習環境和社區功能。
          </p>
          <div className="flex items-center justify-center space-x-2 text-green-600">
            <Rocket className="w-5 h-5" />
            <span className="font-medium">即將推出</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightMathsZone; 